import styled from 'styled-components'

import {
  backgroundTypes,
  boxModelTypes,
  cssTypes,
  displayTypes,
  flexboxTypes,
} from '../types'
import { background, boxModel, css, display, flexbox } from '../util'

/**
 * @namespace View
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const View = styled.div`
  ${background};
  ${boxModel};
  ${css};
  ${display};
  ${flexbox};
`

/**
 * @name defaultProps
 * @memberof View
 * @desc Primitive's default properties
 */
View.defaultProps = {
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof View
 * @desc Primitive's prop type definitions
 */
View.propTypes = {
  ...backgroundTypes,
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
  ...flexboxTypes,
}

/** @component */
export default View
